import 'jquery';
import 'magnific-popup';
import $ from "jquery";

import { convertToHtmlElement } from "./common";

export interface IPopup {
    open(htmlContent: string);
    openRawHtml(htmlContent: string);
    openAndLoadAsync(htmlContentLoader: () => Promise<string>): Promise<void>
    close();
    isOpen(): boolean;
}

export enum PopupWidth {
    Mini = 'mini',
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
    Max = 'max'
}

export interface PopupOptions {
    id: string;
    width: PopupWidth;
    closeOnBgClick?: boolean;
}

export default class MagnificPopup implements IPopup {
    private options: PopupOptions;

    constructor(options: PopupOptions = null) {
        this.options = options ? options : { id: null, width: PopupWidth.Large, closeOnBgClick: false };
    }

    public openRawHtml(htmlContent: string) {
        $.magnificPopup.close();

        $.magnificPopup.open({
            items: {
                src: htmlContent,
                type: 'inline'
            }
        });
    }

    public open(htmlContent: string) {
        $.magnificPopup.open({
            items: {
                src: `<div data-popup class="white-popup ${this.getPopupWidthClass()}"${this.renderId()}>${htmlContent}</div>`,
                type: 'inline',
            },
            closeOnBgClick: this.options.closeOnBgClick
        });
    }


    public async openAndLoadAsync(htmlContentLoader: () => Promise<string>): Promise<void> {
        const popupContentId = `popup_${Date.now()}`;
        $.magnificPopup.open({
            items: {
                src: `<div data-popup class="white-popup ${this.getPopupWidthClass()}"${this.renderId()}><div class="popup-loading" id="${popupContentId}"><div class="loading-icon"><div></div><div></div><div></div></div></div></div>`,
                type: 'inline',
            },
            closeOnBgClick: this.options.closeOnBgClick
        });
        const htmlContent = await htmlContentLoader();
        var contentElement = document.querySelector(`#${popupContentId}`);
        contentElement.replaceWith(convertToHtmlElement(htmlContent));
    }

    public close() {
        $.magnificPopup.close();
    }

    public get isOpen() {
        return $.magnificPopup.instance.isOpen;
    }

    private getPopupWidthClass(): string {
        return this.options.width ? this.options.width.toString() : PopupWidth.Large.toString();
    }

    private renderId(): string {
        if (!this.options.id)
            return '';

        return ` id="${this.options.id}"`;
    }
}
